import { Action } from '@ngrx/store';

import { UserLogin } from './../user-login.model';

export const TRY_SIGNIN = 'TRY_SIGNIN';
export const TRY_SIGNIN_BY_HASH = 'TRY_SIGNIN_BY_HASH';
export const TRY_SIGNIN_BY_MAGIC_LINK = 'TRY_SIGNIN_BY_MAGIC_LINK';
export const SIGNIN = 'SIGNIN';
export const SET_TOKEN = 'SET_TOKEN';

export class TrySignin implements Action {
  readonly type = TRY_SIGNIN;

  constructor(public payload: UserLogin) { }
}

export class TrySigninByHash implements Action {
  readonly type = TRY_SIGNIN_BY_HASH;

  constructor(public email: string, public hash: string) { }
}

export class Signin implements Action {
  readonly type = SIGNIN;
}

export class SetToken implements Action {
  readonly type = SET_TOKEN;

  constructor(public payload: string) { }
}

export type AuthActions = TrySignin | TrySigninByHash | Signin | SetToken;
